export default __webpack_public_path__ + "static/media/message-icon.41b8a2be.svg";